import { useRef } from 'react'
import { Field, Form } from 'react-final-form'
import { Helmet } from 'react-helmet-async'
import { FormattedMessage, useIntl } from 'react-intl'
import { usePwdResetRequestMutation } from '@mwxltd/flix-api-client'
import { Button, ButtonRow } from '@flix/common/elements/controls'
import { FormError } from '@flix/common/elements/forms/FormError/FormError'
import { requiredEmail } from '@flix/common/elements/forms/validators'
import { TextInput } from '@flix/common/elements/input'
import { Background } from '@flix/common/elements/layout/Modal'
import { H2, Paragraph } from '@flix/common/elements/typography'
import formMsgs from '../../../components/forms/messages'
import ModalPage from '../../../components/modals/ModalPage'
import { useSnackbar } from '../../../containers/app/Snackbar/SnackbarContext'
import { canonicalUrl } from '../../../utils/htmlHead'
import meta from '../../metaDescriptions'
import messages from './messages'

const PwdResetRequestPage = ({ history, location }) => {
  const { snackbarMsg, snackbarError } = useSnackbar()
  const emailField = useRef(null)
  const intl = useIntl()

  const [requestPwdReset] = usePwdResetRequestMutation({
    onCompleted() {
      snackbarMsg(
        intl.formatMessage(messages.linkSent),
        intl.formatMessage(messages.checkInbox),
        {},
      )
    },
    onError: (error) => {
      snackbarError(error)
      emailField.current?.focus()
    },
  })

  return (
    <ModalPage>
      <Helmet>
        <title>{intl.formatMessage(meta.pwdResetReq)}</title>
        <link rel="canonical" href={canonicalUrl(location)} />
      </Helmet>

      <Background padded>
        <H2>
          <FormattedMessage {...messages.reqHead} />
        </H2>
        <Paragraph mb="medium">
          <FormattedMessage {...messages.enterEmail} />
        </Paragraph>

        <Form onSubmit={requestPwdReset}>
          {({ handleSubmit, submitting, submitSucceeded }) => (
            <>
              <Field
                name="email"
                validate={requiredEmail}
                render={(fieldProps) => (
                  <TextInput
                    {...fieldProps}
                    ref={emailField}
                    textContentType="emailAddress"
                    onSubmitEditing={handleSubmit}
                    returnKeyType="go"
                  />
                )}
              />

              <FormError />

              <ButtonRow>
                {submitSucceeded ? (
                  <Button
                    onPress={() => history.replace('/sign-in')}
                    intlMsg={messages.backToSignIn}
                  />
                ) : (
                  <>
                    {!submitting && (
                      <Button
                        onPress={history.goBack}
                        intlMsg={formMsgs.cancel}
                        link
                        underline={false}
                        mb="none"
                      />
                    )}
                    <Button
                      onPress={handleSubmit}
                      disabled={submitting}
                      intlMsg={submitting ? messages.requesting : messages.reqReset}
                      mb="none"
                    />
                  </>
                )}
              </ButtonRow>
            </>
          )}
        </Form>
      </Background>
    </ModalPage>
  )
}

export default PwdResetRequestPage
